import { ContactEmailAddress } from '../Constants';

export const faqDataArray = [
  {
    question: 'What services do you offer?',
    answer:
      'I provide an elite selection of BDSM experiences, including domination, roleplay, bondage, sensory play, and more. Each session is uniquely tailored to individual desires and boundaries.',
  },
  {
    question: 'Do you travel across Europe for sessions?',
    answer:
      'Yes, I offer exclusive travel sessions within Europe for dedicated clients. These must be arranged well in advance and require full travel expenses and session fees to be covered.',
  },
  {
    question: 'What are your session rules and expectations?',
    answer:
      'Respect, communication, and consent are non-negotiable. I expect all clients to adhere to My guidelines, which are clearly outlined on My website. Failure to do so will result in a terminated session.',
  },
  {
    question: 'Can I request specific outfits or themes for a session?',
    answer:
      'Absolutely! I take pleasure in incorporating wardrobe, roleplay, and themes into My sessions. Let Me know your preferences when booking, and I will do My best to accommodate them.',
  },
  {
    question: 'Is there a deposit required for booking?',
    answer:
      'Yes, a €50 deposit is mandatory to secure your session. This ensures My time is respected and prevents timewasters.',
  },
  {
    question: 'What happens if I need to cancel my session?',
    answer: `If you must cancel, please provide at least 24 hours’ notice via email ${ContactEmailAddress}. Deposits are non-refundable, but rescheduling may be possible under certain conditions.`,
  },
];

export const secondFaqSectionArray = [
  {
    question: 'How do I book a session?',
    answer:
      'To book a session, visit My Real Time tab and familiarize yourself with My requirements. Once ready, head to My Contact page and follow the instructions for scheduling. A deposit is required to confirm your booking.',
  },
  {
    question: 'Do you offer same-day bookings?',
    answer:
      'Yes, but only if I receive your email and full payment before 12 PM on the day you wish to book.',
  },
  {
    question: 'Do you accept outcalls or hotel bookings?',
    answer:
      'No, I do not offer outcalls or hotel bookings. All sessions take place in My controlled environment. I offer Zoom as an alternative',
  },
  {
    question: 'Do you offer sessions for couples?',
    answer:
      'Yes, I love couple sessions! I welcome all genders and require a group chat before the session to ensure clear communication and trust between all involved.',
  },
  {
    question: 'Do you film sessions?',
    answer: 'I do not offer filming..',
  },
  {
    question: 'Do you offer only ballbusting?',
    answer:
      'While I LOVE ballbusting, My interests span far beyond that! Foot worship, face-sitting, pegging, corporal punishment—these are just a few of the many experiences I offer. Sessions are always tailored to your kinks and desires.',
  },
  {
    question: 'Do you offer 30-minute sessions?',
    answer:
      'Yes, but I charge the same as a full hour session. I put the same effort into preparing and ensuring a quality experience, so if you want Me to compress an hour into 30 minutes, the fee remains unchanged.',
  },
  {
    question: 'Do you offer sexual acts or use subs for sexual pleasure?',
    answer:
      'No. Unless you wear My collar and your chastity key dangles from My neck.',
  },
  {
    question: 'Do you accept submissives with "no limits"?',
    answer:
      'There is no such thing as a submissive with “no limits.” I do offer No Mercy CBT sessions, but these are only for submissives who understand their own boundaries and trust Me to push them safely beyond.',
  },
];
